<template>
  <div class="card" style="width: 850px; height: 450px;overflow: auto;">
    <div class="card-modal">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ mode }} Traveler Program</p>
        <button type="button" class="delete" @click="$emit('close')"></button>
      </header>
      <section class="">
        <div class="box" style=" margin: auto; ">
          <div class="columns is-mobile">
            <div class="column sect">
              <div class="box profile">
                <div class="has-text-centered is-centered">
                  <p class="title is-5" style="">
                    Traveler Program Information
                    <b-loading
                      :is-full-page="true"
                      v-model="loading"
                      :can-cancel="false"
                      size="is-large"
                      type="is-primary"
                    >
                    </b-loading>
                  </p>
                </div>

                <br />
                <b-notification
                  type="is-danger is-light"
                  class="my-3"
                  v-if="validationErrors.length > 0"
                >
                  <h4 class="is-size-5">
                    Please correct the following errors:
                  </h4>
                  <div class="content">
                    <ul>
                      <li
                        v-for="(validationError, index) in validationErrors"
                        :key="index"
                      >
                        {{ validationError }}
                      </li>
                    </ul>
                  </div>
                </b-notification>

                <div class="columns is-mobile">
                  <div class="column sect">
                    <div class="columns">
                      <div class="column is-half">
                        <section>
                          <b-field label="Program Type">
                            <b-select
                              v-model="program.type"
                              placeholder="Select Program Type"
                              expanded
                              required
                            >
                              <option value="Air">Air</option>
                              <option value="Car">Car</option>
                              <option value="Hotel">Hotel</option>
                            </b-select>
                          </b-field>
                        </section>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column is-6">
                        <section>
                          <b-field>
                            <template #label>
                              Select Traveler Program
                            </template>
                            <b-select
                              placeholder="Select Traveler Program"
                              v-model="program.providerCode"
                              required
                              expanded
                            >
                              <option value="">--None--</option>
                              <option
                                v-for="option in getVendorPrograms"
                                :value="option.code"
                                :key="option.code"
                              >
                                {{ option.name }}
                              </option>
                            </b-select>
                          </b-field>
                        </section>
                      </div>
                      <div class="column is-6">
                        <section>
                          <b-field label="Account Number">
                            <b-input
                              v-model="program.accountNumber"
                              required
                              validation-message="Please enter account number/traveler program number."
                            ></b-input>
                          </b-field>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
                <b-button @click="saveInfo()" type="is-primary" expanded
                  >Save Information</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  props: ["travelerprogram", "mode","user"],

  data() {
    return {
      loading: false,
      program: this.travelerprogram,
      validationErrors: [],
    };
  },
  methods: {
    validateForm() {
      var errors = [];
      if (!this.program.type) {
        errors.push("Program type is required");
      }
      if (!this.program.providerCode) {
        errors.push("Traveler program is required");
      }
      if (!this.program.accountNumber) {
        errors.push("Account number is required");
      }
      this.validationErrors = errors;

      if (errors.length > 0) {
        return false;
      }

      return true;
    },

    saveInfo() {
      this.validateForm();

      if (this.validateForm()) {
        this.loading = true;

        var body = { contactId: this.profile.id,userId:this.user.id, program: this.program };

        this.$app
          .huddleLabsServerCall("profile/traveler-programs/create", body)
          .then((result) => {
            if (!result.error) {
              if (!result.success) {
                this.failure(result.error_message);

                this.loading = false;
              } else {
                this.loading = false;
                this.success();
                this.$emit("upload-success");
                this.$emit("close");
              }
            } else {
              this.failure(result.error_message);

              console.log(result);
              this.loading = false;
            }
          })
          .catch((error) => {
            this.loading = false;

            this.failure(error);

            console.log(error);
          });
      }
    },
    success() {
      this.$buefy.toast.open({
        message: "Traveler program successfully saved",
        type: "is-success",
      });
    },
    failure(msg = "") {
      this.$buefy.toast.open({
        duration: 5000,
        message: "There was an error saving your traveler program" + msg,
        position: "is-bottom",
        type: "is-danger",
      });
    },
  },
  mounted() {
    console.log(this.program);
  },
  computed: {
    getVendorPrograms() {
      if (this.program.type == "Air")
        return this.$store.state.userManagement.airVendorsFields;
      else if (this.program.type == "Car")
        return this.$store.state.userManagement.carVendorsFields;
      else if (this.program.type == "Hotel")
        return this.$store.state.userManagement.hotelVendorsFields;
      else return [];
    },
    profile() {
      return this.$globals.profile;
    },
  },
};
</script>
